import styles from './Footer.module.css'

export default function OpenFinance({ bottom }) {
    return (
        <div className={styles.footer} style={{ bottom }}>
            <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', width:'100%' }}>
                <img src={'/open_finance.png'} className="open_finance-logo" alt="open finance logo" style={{ width: '150px', maxHeight: '60px' }}/>
                <img src={'/akropoli2.png'} className="open_finance-logo" alt="open finance logo" style={{ width: '150px', maxHeight: '40px' }}  />
            </div>
        </div>
    )
}